import { render } from "./ShResultsPage.vue?vue&type=template&id=0670b131&scoped=true"
import script from "./ShResultsPage.vue?vue&type=script&lang=js"
export * from "./ShResultsPage.vue?vue&type=script&lang=js"

import "./ShResultsPage.vue?vue&type=style&index=0&id=0670b131&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0670b131"]])

export default __exports__